import { UI, VStack } from '@genial/components';
import React from 'react';

export interface SubscriptionItemDetailsFooterProps {
  title: string;
  subtitle: string;
}

export const SubscriptionItemDetailsFooter: React.FC<SubscriptionItemDetailsFooterProps> = ({
  title,
  subtitle,
}) => {
  return (
    <VStack space="stack.xxxs">
      <UI.Text color="brand.primary.principal">{title}</UI.Text>
      <UI.Text color="brand.primary.principal">{subtitle}</UI.Text>
    </VStack>
  );
};
